// 组件工厂

import * as $ from 'jquery';

import components from './app.components';

export default {
    // 创建组件实例
    create(params: {
        selector: any;   // 组件插座的选择器（例如：'#workflow', document.body）
        component: string;  // 组件名
        data?: any;
    }) {
        // 存在组件
        if (!components[params.component]) {
            console.log(`未找到"${params.component}"组件`);
            return;
        }

        // 存在dom slot
        let slot: any;
        if ('string' === typeof params.selector) {
            slot = $(params.selector) && $(params.selector)[0]
        } else {
            slot = params.selector;
        }
        if (!slot) {
            console.log(`未找到"${params.selector}"元素`);
            return;
        }

        // 创建组件并添加到slot上
        const component = new components[params.component]({
            data: params.data || {}
        });
        component.attach(slot);
        return component;
    }
}
